import type { RegionKey } from '@artifax/shared';
import { REGION_FULL_NAMES, REGION_KEYS, REGION_LABELS } from '@artifax/shared';

interface Props {
  region: RegionKey;
  detected: RegionKey;
  onChange: (region: RegionKey) => void;
}

export function RegionTabs({ region, detected, onChange }: Props) {
  return (
    <div className="tabsrow">
      <div className="tabs" role="group" aria-label="Choose region">
        {REGION_KEYS.map((key) => (
          <button
            key={key}
            type="button"
            aria-pressed={region === key}
            aria-label={`Show ${REGION_FULL_NAMES[key]} region`}
            className={region === key ? 'tab tab--active' : 'tab'}
            onClick={() => onChange(key)}
          >
            {REGION_LABELS[key]}
          </button>
        ))}
      </div>
      <p className="detect">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        <span>Auto-detected: {REGION_FULL_NAMES[detected]}</span>
      </p>
    </div>
  );
}
